import { createSlice } from "@reduxjs/toolkit";
import { getTeacherSlots } from "./teacherSlotsThunk";

const initialState = {
  data: null,
  loading: false,
  error: null,
  success: null,
  errorMessage: "",
};

export const weekDaysSlice = createSlice({
  name: "content",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTeacherSlots.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTeacherSlots.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.success = true;
      state.data = action.payload;
    });
    builder.addCase(getTeacherSlots.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default weekDaysSlice.reducer;
